// ============================================================================
// History blocks — scroll-spy for the sticky era nav + per-article reveal
// ============================================================================
(function ($) {
    'use strict';

    $(function () {
        const $section = $('#history-blocks');
        if (!$section.length) return;

        const $articles = $section.find('[data-era-block]');
        const $navItems = $section.find('.history-blocks__nav-item');

        if (!$articles.length || !$navItems.length) return;

        // Lookup: article id → nav item
        const navByTarget = {};
        $navItems.each(function () {
            const $a = $(this).find('a').first();
            const href = $a.attr('href') || '';
            const id = href.replace(/^#/, '');
            if (id) navByTarget[id] = this;
        });

        function setActive(id) {
            $navItems.removeClass('is-active');
            const el = navByTarget[id];
            if (el) el.classList.add('is-active');
        }

        // Scroll-spy — narrow trigger band so only one article is active at a time
        const spy = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    setActive(entry.target.id);
                }
            });
        }, {
            root: null,
            rootMargin: '-35% 0px -55% 0px',
            threshold: 0,
        });

        $articles.each(function () { spy.observe(this); });

        // Per-article reveal on first scroll-into-view
        const reveal = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                entry.target.classList.add('is-revealed');
                reveal.unobserve(entry.target);
            });
        }, {
            root: null,
            rootMargin: '0px 0px -10% 0px',
            threshold: 0.1,
        });

        $articles.each(function () { reveal.observe(this); });
    });
})(jQuery);
